module.exports = __webpack_public_path__ + "img/monitor_cover_sol.ceec2608.png";